import { addDoc, collection } from "firebase/firestore"
import { dbFirestore } from "../../general/firebase"
import { encryptNIP } from "../../general/functions"


/** Save to Firebase */
const processFirebase = async function (mentions) {
  const curNIP = ['2109010001', '1105220001'];
  const curName = ['Al Mixev Victoro', 'Kevin Putra Wangsa'];
  // const curNIP = ['1909090001'];
  // const curName = ['Nyoman Tri Anjasmara'];
  const curRes = [];

  for (let i = 0; i < curNIP.length; i++) {
    const notifyPath = `User/${encryptNIP(curNIP[i])}/Notification`;

    const docRef = await addDoc(collection(dbFirestore, notifyPath), {
      type: 'PENDING_TRANSACTION',
      targetNIP: curNIP[i],
      targetName: curName[i],
      creatorName: mentions.creatorName,
      isRead: false,
      creator: mentions.creatorNIP,
      created: Date.now(),
      others: mentions.data === null ? null : mentions.data,
      version: mentions.version ?? 0,
    });

    curRes.push({
      nip: curNIP[i],
      id: docRef.id,
    });
  }

  return curRes;
}

export {
    processFirebase
}